"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudioFileField = void 0;
const EditorFieldBase_1 = require("./EditorFieldBase");
class StudioFileField extends EditorFieldBase_1.EditorFieldBase {
}
exports.StudioFileField = StudioFileField;
